import React from 'react'

export const FilterAppliedIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <circle fill='#49C62D' cx='8' cy='8' r='8' />
        <path d='M3 3h10v10H3z' />
        <path fill='#FFF' d='m4.563 7.688-.938.937 2.5 2.5 5.625-5.313-.938-.937L6.125 9.25z' />
      </g>
    </svg>
  )
}
